import env from "../env"
import { dataAPI } from "./api"
import {
    PreviewFeatureOData,
    PreviewFeaturesODataResponse,
} from "./models/previewfeature"

import { ODataGetArrayResponse } from "./models/api/data"
import { PreviewFeature, ReleaseStage } from "../models"

export const getEnabledPreviewFeatures =
    (): Promise<PreviewFeaturesODataResponse> =>
        dataAPI
            .getJSON<ODataGetArrayResponse<PreviewFeatureOData>>(
                `users/${env.loggedOnPersonId}/previewfeatures`,
                {
                    $count: true,
                },
            )
            .then((response) => ({
                count: response["@count"] ?? 0,
                previewFeatures: response.value.map(
                    (previewFeature): PreviewFeature => ({
                        id: previewFeature.Id,
                        label: previewFeature.Label,
                        description: previewFeature.Description,
                        releaseStage: previewFeature.ReleaseStage,
                    }),
                ),
            }))

export const getBetaPreviewFeatures =
    (): Promise<PreviewFeaturesODataResponse> =>
        dataAPI
            .getJSON<ODataGetArrayResponse<PreviewFeatureOData>>(
                "previewfeatures",
                {
                    $filter: "ReleaseStage eq TF.ReleaseStage'Beta'",
                    $count: true,
                },
            )
            .then((response) => ({
                count: response["@count"] ?? 0,
                previewFeatures: response.value.map(
                    (previewFeature): PreviewFeature => ({
                        id: previewFeature.Id,
                        label: previewFeature.Label,
                        description: previewFeature.Description,
                        releaseStage:
                            previewFeature.ReleaseStage || ReleaseStage.Beta,
                    }),
                ),
            }))

export const enablePreviewFeatureForUser = (
    previewFeatureId: number,
): Promise<void> =>
    dataAPI.postJSON(`users/${env.loggedOnPersonId}/previewfeatures/$ref`, {
        id: previewFeatureId,
    })

export const disablePreviewFeatureForUser = (
    previewFeatureId: number,
): Promise<void> =>
    dataAPI.remove(
        `users/${env.loggedOnPersonId}/previewfeatures/${previewFeatureId}/$ref`,
    )
